import { useState } from "react";

export const useCaptcha = () => {
  const generateRandomNumbers = () => ({
    num1: Math.floor(Math.random() * 10),
    num2: Math.floor(Math.random() * 10),
  });

  const [numbers, setNumbers] = useState(generateRandomNumbers());

  const checkAnswer = (userAnswer: number): boolean => {
    const correctAnswer = numbers.num1 + numbers.num2;
    return userAnswer === correctAnswer;
  };

  const resetCaptcha = () => {
    setNumbers(generateRandomNumbers());
  };

  return {
    num1: numbers.num1,
    num2: numbers.num2,
    checkAnswer,
    resetCaptcha,
  };
};
